// extracted by mini-css-extract-plugin
module.exports = {"title":"AppHeaderLink_title__dpJ5N","active":"AppHeaderLink_active__dQh7j","indicator":"AppHeaderLink_indicator__cXqPO"};